<template>

  <div>

    <el-row>
      <el-col :span="20">
        <div v-for="(item, n) in value" :key="n" class="mb-1 d-flex">

          <time-range-picker v-model="value[n]" />

          <el-button type="text" @click="removeHours(n)" icon="el-icon-delete" circle></el-button>

        </div>
      </el-col>
      <el-col :span="4">
        <el-button type="text" @click="addHours">Add hours</el-button>
      </el-col>
    </el-row>

  </div>

</template>
<script>
import TimeRangePicker from './TimeRangePicker';
export default {
  props: ['value'],
  components: {
    TimeRangePicker
  },
  mounted() {

  },
  methods: {
    addHours() {
      this.value.push({
        opens: '09:00',
        closes: '18:00'
      });
    },
    removeHours(index) {
      this.value.splice(index, 1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// TimeArrayPicker.vue?6fba2e83